export const GET_LOCATIONS = 'GET_LOCATIONS';


// WEBPACK FOOTER //
// ./src/containers/locations/types.js